<template>
  <v-list-item v-if="!isEditing" ripple class="it-hv">
    <abt-item-avatar :icon="'fal fa-id-card'" :note="''" />
    <v-list-item-content>
      <v-list-item-subtitle class="caption" v-if="isStatusYes || isStatusDone"><span class="font-weight-bold" v-if="!isTypeEmpty">種類：</span>{{ printType }}</v-list-item-subtitle>
      <v-list-item-title>{{ (isStatusYes || isStatusDone) ? printCountry : printStatus }}</v-list-item-title>
      <v-list-item-subtitle class="caption" v-if="isStatusYes">
        <span class="font-weight-bold" v-if="!isTermEmpty">有効期間：</span>{{ printTerm }}
      </v-list-item-subtitle>
      <v-list-item-subtitle class="caption" v-if="isStatusDone">
        <span class="font-weight-bold">発行日：</span>{{ printPublishDate }}
      </v-list-item-subtitle>
      <v-list-item-subtitle class="caption" v-if="isStatusNo">
        <span class="font-weight-bold">手配：</span>{{ printArranger }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom v-if="!isStatusDone">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading || isLoading" @click="edit">
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
      <v-menu offset-y v-else>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading">
            <v-icon small>fa-ellipsis-v</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="edit">
            <v-list-item-avatar>
              <v-icon small>fal fa-pencil</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>編集する</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="remove">
            <v-list-item-avatar>
              <v-icon small>fal fa-trash-alt</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>削除する</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list-item-action>
    <UtilConfirmModal ref="confirm"></UtilConfirmModal>
  </v-list-item>
  <v-container v-else>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3" v-if="!isStatusDone">
        <v-radio-group required row
          v-model="form.status"
          :rules="rules.status"
          @change="changed">
          <v-radio v-for="(item, key) in getStatusItems" :key="key"
            color="blue darken-2"
            :label="item"
            :value="key"
          />
        </v-radio-group>
      </v-col>
      <v-col cols="12" class="px-3" v-if="isFormStatusYes || isFormStatusDone">
        <v-select
          v-model="form.country"
          label="発行国"
          item-text="label"
          item-value="code"
          :rules="rules.country"
          :items="getNationItems"
        />
      </v-col>
      <v-col cols="12" class="px-3" v-if="isFormStatusYes || isFormStatusDone">
        <v-select
          v-model="form.type"
          label="ビザの種類"
          item-text="text"
          item-value="value"
          :rules="rules.country"
          :items="getTypeItems"
        />
      </v-col>
      <v-col cols="12" class="px-3" v-if="isFormStatusYes || isFormStatusDone">
        <v-menu lazy offset-y full-width
          v-model="config.datepicker.publish"
          transition="scale-transition"
          min-width="290px"
          :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-text-field readonly required
              v-model="printFormatedPublish"
              v-on="on"
              :rules="rules.publish"
              label="発行日"
            />
          </template>
          <v-date-picker
            v-model="form.publish"
            color="amber"
            locale="ja"
            :day-format="date => new Date(date).getUTCDate()"
            @input="config.datepicker.publish = false"
          />
        </v-menu>
      </v-col>
      <v-col xs12 class="px-3" v-if="isFormStatusYes">
        <v-menu lazy offset-y full-width
          v-model="config.datepicker.expire"
          transition="scale-transition"
          min-width="290px"
          :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-text-field readonly required
              v-model="printFormatedExpire"
              v-on="on"
              :rules="rules.expire"
              label="失効日"
            />
          </template>
          <v-date-picker
            v-model="form.expire"
            color="amber"
            locale="ja"
            :day-format="date => new Date(date).getUTCDate()"
            @input="config.datepicker.expire = false"
          />
        </v-menu>
      </v-col>
      <v-col xs12 class="px-3" v-if="isFormStatusNo">
        <v-radio-group required row
          v-model="form.arranger"
          :rules="rules.arranger">
          <v-radio v-for="(item, key) in getArrangerItems" :key="key"
            color="blue darken-2"
            :label="item"
            :value="key"
          />
        </v-radio-group>
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import UtilConfirmModal from '@/components/modals/confirm'
import AbtItemAvatar from '../../../../components/avatar'
export default {
  name: 'clientAboutBackgroundsVisa',
  components: {
    UtilConfirmModal,
    AbtItemAvatar
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        type: 'visa',
        status: {
          loading: false
        },
        datepicker: {
          publish: false,
          expire: false
        }
      },
      form: {
        id: '',
        status: '',
        country: '',
        type: '',
        publish: '',
        expire: '',
        arranger: ''
      },
      rules: {
        status: [
          v => !!v || '必須項目です'
        ],
        country: [
          v => !!v || '必須項目です'
        ],
        type: [
          v => !!v || '必須項目です'
        ],
        publish: [
          v => !!v || '必須項目です'
        ],
        expire: [
          v => !!v || '必須項目です'
        ],
        arranger: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function (dt) {
      if (dt) {
        this.$set(this, 'form', {
          id: '' + (dt.id ? dt.id : ''),
          status: dt.status ? dt.status : '',
          country: dt.country ? dt.country : '',
          type: dt.type ? dt.type : '',
          publish: dt.publish ? dt.publish : '',
          expire: dt.expire ? dt.expire : '',
          arranger: dt.arranger ? dt.arranger : ''
        })
      } else if (this.$props.data) {
        this.$set(this, 'form', {
          id: '' + (this.$props.data.id ? this.$props.data.id : ''),
          status: this.$props.data.status ? this.$props.data.status : '',
          country: this.$props.data.country ? this.$props.data.country : '',
          type: this.$props.data.type ? this.$props.data.type : '',
          publish: this.$props.data.publish ? this.$props.data.publish : '',
          expire: this.$props.data.expire ? this.$props.data.expire : '',
          arranger: this.$props.data.arranger ? this.$props.data.arranger : ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          id: (this.$props.data && this.$props.data.id) ? ('visa_' + this.$props.data.id) : '',
          type: this.config.type
        }
      })
    },
    changed: function () {
      this.prepare({
        id: '' + (this.$props.data.id ? this.$props.data.id : ''),
        status: this.form.status ? this.form.status : ''
      })
    },
    remove: function () {
      this.$refs.confirm.open({
        title: 'ビザ取得歴の削除',
        message: 'このビザ取得歴を削除してもよろしいですか？',
        callback: () => {
          this.$set(this.config.status, 'loading', true)
          this.$firebase.auth().currentUser.getIdToken(true).then(token => {
            this.axios.post(this.$url.api + 'about/delete/meta', {
              id: this.$props.data.id,
              cid: this.$route.params.id
            }, {
              headers: {
                'firebase-token': token
              }
            }).then(res => {
              console.log(res)
              if (res.data && res.data.success) {
                this.$emit('emit', {
                  action: 'remove',
                  data: {
                    type: 'visas',
                    id: res.data.data.id ? res.data.data.id : ''
                  }
                })
              }
            })
          })
        }
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        (this.$props.status.editing === 'all' || this.$props.status.editing === ('visa_' + this.$props.data.id))
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.editing === ('visa_' + this.$props.data.id)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.loading === ('visa_' + this.$props.data.id)
      )
    },
    printStatus () {
      return (
        this.$props.data &&
        this.$props.data.status &&
        this.$mango.about.visa.status[this.$props.data.status]
      ) ? this.$mango.about.visa.status[this.$props.data.status] : 'ビザの回答'
    },
    isStatusYes () {
      return !!(
        this.$props.data &&
        this.$props.data.status &&
        this.$props.data.status === 'YES'
      )
    },
    isStatusNo () {
      return !!(
        this.$props.data &&
        this.$props.data.status &&
        this.$props.data.status === 'NO'
      )
    },
    isStatusDone () {
      return !!(
        this.$props.data &&
        this.$props.data.status &&
        this.$props.data.status === 'DONE'
      )
    },
    isFormStatusYes () {
      return !!(
        this.form.status === 'YES'
      )
    },
    isFormStatusNo () {
      return !!(
        this.form.status === 'NO'
      )
    },
    isFormStatusDone () {
      return !!(
        this.form.status === 'DONE'
      )
    },
    printCountry () {
      return (
        this.$props.data &&
        this.$props.data.country &&
        this.$mango.nations[this.$props.data.country]
      ) ? this.$mango.nations[this.$props.data.country] : ''
    },
    printType () {
      return (
        this.$props.data &&
        this.$props.data.type &&
        this.$mango.about.visa.types[this.$props.data.type]
      ) ? this.$mango.about.visa.types[this.$props.data.type] : ''
    },
    printTerm () {
      return (
        this.$props.data
      ) ? [
          this.$props.data.publish ? this.$moment(this.$props.data.publish).format('YYYY/MM/DD') : '',
          this.$props.data.expire ? this.$moment(this.$props.data.expire).format('YYYY/MM/DD') : ''
        ].join('〜') : ''
    },
    printPublishDate () {
      return (
        this.$props.data && this.$props.data.publish
      ) ? this.$moment(this.$props.data.publish).format('YYYY/MM/DD') : ''
    },
    printFormatedPublish () {
      return (
        this.form &&
        this.form.publish
      ) ? this.$moment(this.form.publish).format('YYYY/MM/DD') : ''
    },
    printFormatedExpire () {
      return (
        this.form &&
        this.form.expire
      ) ? this.$moment(this.form.expire).format('YYYY/MM/DD') : ''
    },
    printArranger () {
      return (
        this.$props.data &&
        this.$props.data.arranger &&
        this.$mango.about.visa.arrangers[this.$props.data.arranger]
      ) ? this.$mango.about.visa.arrangers[this.$props.data.arranger] : ''
    },
    isStatusEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.status
      )
    },
    isTypeEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.type
      )
    },
    isTermEmpty () {
      return !(
        this.$props.data &&
        [
          this.$props.data.publish ? this.$props.data.publish : '',
          this.$props.data.expire ? this.$props.data.expire : ''
        ].join('')
      )
    },
    getStatusItems () {
      return this.$mango.about.visa.status
    },
    getNationItems () {
      return Object.keys(this.$mango.nations).filter(key => { return key !== 'JP' }).map(key => {
        return {
          code: key,
          label: this.$mango.nations[key]
        }
      })
    },
    getTypeItems () {
      return Object.keys(this.$mango.about.visa.types).map(key => {
        return {
          value: key,
          text: this.$mango.about.visa.types[key]
        }
      })
    },
    getArrangerItems () {
      return this.$mango.about.visa.arrangers
    }
  }
}
</script>
